import React, { useContext, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import {
  Dashboard,
  Login,
  Main,
  Signup,
  Templates,
  Pricing,
  VerifyPayment,
  Interview,
  ForgotPassword
} from "..";
import { auth, db } from "../../firebase";
import { ResumeContextProvider } from "../../contexts/resumeContext";
import { UserContext } from "../../contexts/userContext";
import { doc, getDoc } from "firebase/firestore";

function Router() {
  const navigate = useNavigate();
  const { setUser, user, setUserLoading } = useContext(UserContext);

  const getUserProfile = async (userAuth) => {
    const { uid } = userAuth

    const userSnap = await getDoc(doc(db, "users", uid));
    if (userSnap.exists()) {
      return userSnap.data();
    } 
  };

  useEffect(() => {
    setUserLoading(true);
    onAuthStateChanged(auth, async (userAuth) => {
      if (userAuth) {
        if (!user) {
          const userData = await getUserProfile(userAuth)
          setUser({...userAuth, ...userData});
          // navigate("/", { replace: true });
        }
      }
      setUserLoading(false);
      // else {
      //   navigate("register");
      // }
    });
  }, []);
  return (
    <ResumeContextProvider>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="resume/:docId/edit" element={<Main />} />
        <Route path="designs" element={<Templates />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Signup />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="interview" element={<Interview />} />
        <Route path="verify-payment" element={<VerifyPayment />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
      </Routes>
    </ResumeContextProvider>
  );
}

export default Router;
